function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'7295d9e4843a8c278344898a2b67b562': 'rgb(199, 199, 199)','ca50000a180a293de0b27acb67a695cb': 'rgb(152, 152, 152)','1506aeeb8c3a699b1e3c87db03156428': 'rgb(7, 7, 7)','7a5b2342133a0cfbb741f672ea2ec5e3': 'rgb(3, 11, 113)','1ffd9e753c8054cc61456ac7fac1ac89': 'rgb(17, 17, 17)','48d6215903dff56238e52e8891380c8f': 'rgb(0, 116, 217)','65cb59645b852c2394ba3ff8b295e83c': 'rgb(127, 219, 255)','3c4184e82bb3be8fa32669800fb7373c': 'rgb(57, 204, 204)','f431b0eea3c08186ed101e588bfb3a2f': 'rgb(128, 128, 0)','9f27410725ab8cc8854a2769c7a516b8': 'rgb(46, 204, 64)','67c0ecaf5a1b782b11146e9fbe80f016': 'rgb(1, 255, 112)','d487dd0b55dfcacdd920ccbdaeafa351': 'rgb(255, 220, 0)','fe01d67a002dfa0f3ac084298142eccd': 'rgb(255, 133, 27)','bda9643ac6601722a28f238714274da4': 'rgb(255, 65, 54)','9f370737a8ad22210a0dd6b1c8f00896': 'rgb(240, 18, 190)','bb7aedfa61007447dd6efaf9f37641e3': 'rgb(177, 13, 201)','04a3da97880fcedeb087378f29c3a102': 'rgb(133, 20, 75)','97f014516561ef487ec368d6158eb3f4': 'rgb(221, 221, 221)','4a0b0dcedd48f780778d1cd1bb8f9877': 'rgb(250, 190, 190)','6ff47afa5dc7daa42cc705a03fca8a9b': 'rgb(154, 99, 36)','8b823f49ba31caa5cd88e520c2f82bdc': 'rgb(170, 255, 195)','153fa52654465ad67f045dc293f3b16e': 'rgb(230, 190, 255)','5b2d4484498235e80d61a233a7c04991': 'rgb(160, 78, 59)','9ad690722666019935864defc71d4fa7': 'rgb(161, 87, 50)','8a99d28c3c43cafed58cdbac5f4e9201': 'rgb(45, 46, 51)','31ba6d3619a6d70c983151afa0764de4': 'rgb(118, 105, 82)','42133a3dcbeafd8d1b0a68cae646de2a': 'rgb(101, 97, 104)','64e12ab6aa0d4c7473286d43b6a35fc8': 'rgb(103, 109, 141)','6470cf0793828d30504b1b643eaf1613': 'rgb(152, 152, 152)','527311c8036135de379d6ef0974f813a': 'rgb(17, 17, 17)','0b0eb769e5c5da8f33ac9ee372bdf5c3': 'rgb(0, 116, 217)','58547deb83a690619994bf56f56a84ec': 'rgb(17, 17, 17)','ea9030d15b97b5b4169a022994ec2c3a': 'rgb(195, 119, 0)','5bc7a96888cb3eeb5cda6dafa715aa99': 'rgb(199, 199, 199)','dc58a7971816b41f3cc2b8c0f5f1bf0c': 'rgb(0, 0, 0)','ca6f7477c282b568832bf9d538fa2c3b': 'rgb(252, 27, 154)','d810f81838e1115ac24e101f51aaf7bb': 'rgb(187, 253, 92)',};

    this.images = {'e66fff58c5f3e5584095b296204a9794': 'url("//theragcompany.com/cdn/shop/files/ice-grey-and-grey_68x.png?v=42551")','1e3fce2611a29120b06d6cf99ec01a63': 'url("//theragcompany.com/cdn/shop/files/aqua-and-grey_68x.png?v=42551")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
